<template lang="html">
  <div id="app" class="main column no-header">
		<div class="background-login">
			<!-- <img src="~@/assets/img/courbe-back.svg" alt=""> -->
		</div>
		<div v-if="hardLogin" class="login login-form" :class="{active: login}">
			<div class="login-logo">
				<logo />
			</div>
			<form class="form-ui column" novalidate v-on:keyup.enter="connect">
				<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('email')}">
					<label for="email" class="active">Votre e-mail</label>
					<input data-vv-validate-on="blur" v-validate="'required|email'" type="email" name="email" v-model="email">
				</div>
				<div v-if="errors.has('email')" class="error-message">{{ errors.first('email') }}</div>
				<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('password')}">
					<label for="password" class="active">Mot de passe</label>
					<input v-validate="'required'" type="password" name="password" v-model="password">
				</div>
				<div v-if="errors.has('password')" class="error-message">{{ errors.first('password') }}</div>
			</form>
			<div class="ctn-password-reset link" @click="$router.push({ name: 'ResetPasswordEmailAsk' })">
				Mot de passe oublié ?
			</div>
			<div class="ctn-connect">
				<div class="btn btn-red" @click="connect">
					Connexion
				</div>
			</div>
		</div>
		<div v-if="!loginusMaximus" class="login forgot-password" :class="{active: !hardLogin}">
			<div class="top">
				<h2>Mot de passe oublié</h2>
				<div class="label">
					Veuillez entrer votre adresse-email pour obtenir un nouveau mot de passe
				</div>
			</div>
			<div class="bottom">
				<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('email oublié')}">
					<label for="email">Votre e-mail</label>
					<input data-vv-validate-on="blur" v-validate="'required|email'" type="email" name="email oublié" v-model="emailReset" v-on:keyup.enter="resetPassword">
				</div>
				<div v-if="errors.has('email oublié')" class="error-message">{{ errors.first('email oublié') }}</div>
				<div class="ctn-connect">
					<div class="btn btn-red" @click="resetPassword">
						Envoyer
					</div>
					<div class="ctn-password-reset link" @click="$router.push({ name: 'Login' })">
						Retour à la connexion
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserResource from '../resources/user'
import Logo from '@/common/components/Logo.vue'

export default {
	name: 'Login',
	components: { Logo },
	data () {
		return {
			email: '',
			password: '',
			emailReset: '',
			login: true,
			hardLogin: true,
			loginusMaximus: true
		}
	},
	mounted () {
		if (this.$route.name === 'ResetPasswordEmailAsk') {
			this.switchViewForth()
		}

		if (this.isUser) this.$router.push({ name: 'Home' })
	},
	watch: {
		$route (to, from) {
			if (to.name === 'ResetPasswordEmailAsk') {
				this.switchViewForth()
			} else {
				this.switchViewBack()
			}
		}
	},
	methods: {
		connect () {
			this.$validator.validate().then((validate) => {
				if (validate) {
					this.$store.dispatch('login', {
						email: this.email,
						password: this.password
					}).then(() => {
						this.$router.push({ name: 'Home' })
					}).catch(() => {
						this.$notify({
							type: 'error',
							group: 'default',
							title: 'Problème lors de la connexion',
							text: 'Mauvais login ou mot de passe'
						})
					})
				}
			})
		},
		resetPassword () {
			this.$validator.validate().then((validate) => {
				if (validate) {
					UserResource.resetPassword(this.emailReset).then((result) => {
						if (result.data.success) {
							this.$notify({
								type: 'success',
								group: 'default',
								title: 'Mot de passe réinitialisé',
								text: 'Vous allez recevoir un email avec votre nouveau mot de passe'
							})
							this.switchViewBack()
						} else {
							this.$notify({
								type: 'error',
								group: 'default',
								title: 'Une erreur est survenue',
								text: 'Votre compte est désactivé, veuillez contacter votre administrateur'
							})
						}
					}).catch(() => {
						this.$notify({
							type: 'error',
							group: 'default',
							title: 'Une erreur est survenue',
							text: 'Il est possible que cette adresse n\'appartienne à aucun compte'
						})
					})
				}
			})
		},
		switchViewForth () {
			this.login = !this.login
			window.setTimeout(() => { this.loginusMaximus = !this.loginusMaximus }, 400)
			window.setTimeout(() => { this.hardLogin = !this.hardLogin }, 500)
		},
		switchViewBack () {
			this.hardLogin = !this.hardLogin
			window.setTimeout(() => { this.loginusMaximus = !this.loginusMaximus }, 400)
			window.setTimeout(() => { this.login = !this.lgin }, 500)
		}
	},
	computed: {
		...mapGetters({
			isUser: 'isUser'
		})
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// Login.vue?20999f18